import { AdjustmentOperation, AdjustmentType, CatalogItem, DemographicPrice, UnitType } from "types";
import { getCatalogItemsByUnitType } from "./Catalog";

export const getDefaultRelativePricingValues = () => {
    return {
        adjustmentAmount: undefined,
        adjustmentOperation: AdjustmentOperation.MARKUP,
        adjustmentType: AdjustmentType.ABSOLUTE,
    };
};

// whenever the amount is configured, we need to use same amount for all demographics/equipment prices
export const generateRelativePricingCatalogItemPrices = (
    catalogItems: CatalogItem[],
    unitType: UnitType,
    adjustmentAmount = undefined,
    adjustmentOperation: AdjustmentOperation = AdjustmentOperation.MARKUP,
    adjustmentType: AdjustmentType = AdjustmentType.ABSOLUTE,
): DemographicPrice[] => {
    const items = getCatalogItemsByUnitType(catalogItems, unitType);
    return items.map((item) => {
        return {
            adjustmentAmount,
            adjustmentOperation,
            adjustmentType,
            template: { id: item.template!.id },
            catalogItem: item,
        };
    });
};

export const generateRelativePricingDemographicPrices = (
    catalogItems: CatalogItem[],
    adjustmentAmount = undefined,
    adjustmentOperation: AdjustmentOperation = AdjustmentOperation.MARKUP,
    adjustmentType: AdjustmentType = AdjustmentType.ABSOLUTE,
): DemographicPrice[] => {
    return generateRelativePricingCatalogItemPrices(
        catalogItems,
        UnitType.DEMOGRAPHIC,
        adjustmentAmount,
        adjustmentOperation,
        adjustmentType,
    );
};
